import { IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useControls } from "react-zoom-pan-pinch";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";

function ZoomOut() {
  const { zoomIn, zoomOut, centerView } = useControls();
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Tooltip title="Zoom Out">
      <IconButton
        aria-label="zoomOut"
        color="primary"
        onClick={(e) => {
          zoomOut(0.2, 100, "easeOut");
          e.currentTarget.blur();
        }}
        sx={{ marginRight: isMobile ? 0 : 2 }}
      >
        <ZoomOutIcon />
      </IconButton>
    </Tooltip>
  );
}

export default ZoomOut;
